// Collection filter grid - 商品グリッドへの自動スクロール
document.addEventListener('DOMContentLoaded', function() {
  // URLにハッシュが含まれているか確認
  const hash = window.location.hash;
  if (hash === '#product-grid' || hash === '#collection-filter-grid') {
    // ターゲット要素を探す
    const targetId = hash.substring(1); // #を除去
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // ページ読み込み後、少し待ってからスクロール（フィルター適用を待つ）
      setTimeout(function() {
        // ヘッダーの高さを考慮（固定ヘッダーがある場合）
        const header = document.querySelector('header') || document.querySelector('.header');
        const headerHeight = header ? header.offsetHeight : 0;

        // スクロール位置を計算（ターゲット要素の上部 - ヘッダー高さ - 余白）
        const scrollPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;

        // スムーススクロール
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });

        // オプション：ターゲット要素にフォーカスを当てる（アクセシビリティ向上）
        targetElement.setAttribute('tabindex', '-1');
        targetElement.focus();

        // URLからハッシュを削除（オプション - 見た目をクリーンに）
        if (history.replaceState) {
          const cleanUrl = window.location.href.split('#')[0];
          history.replaceState(null, null, cleanUrl);
        }
      }, 500); // 500ms待機（フィルター処理が完了するまで）
    }
  }

  // Categories GridやShop by Brandからのリンクに対してもスムーススクロールを適用
  const categoryLinks = document.querySelectorAll('a[href*="#product-grid"], a[href*="#collection-filter-grid"]');
  categoryLinks.forEach(function(link) {
    // 外部リンク（他のページへの遷移）の場合はスキップ
    if (link.hostname === window.location.hostname) {
      link.addEventListener('click', function(e) {
        // 同じページ内の場合のみスムーススクロール
        const url = new URL(link.href);
        if (url.pathname === window.location.pathname) {
          e.preventDefault();
          // ハッシュからターゲットIDを取得
          const hash = url.hash;
          if (hash) {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }
        }
      });
    }
  });
});